module.exports = __webpack_public_path__ + "img/3-(9).848e6203.jpg";